/**
 * useTranslation — React hook, порт из webdex.
 * Реагирует на событие 'language-changed' и обновляет UI.
 */

import { useState, useEffect } from 'react'
import { translate, getSavedLang, type SupportedLang, type TranslationKey } from '@properwallet/i18n'

export function useTranslation() {
  const [lang, setLangState] = useState<SupportedLang>(getSavedLang)

  useEffect(() => {
    const handle = () => setLangState(getSavedLang())
    window.addEventListener('language-changed', handle)
    window.addEventListener('storage', handle)
    return () => {
      window.removeEventListener('language-changed', handle)
      window.removeEventListener('storage', handle)
    }
  }, [])

  const t = (key: TranslationKey): string => translate(key, lang)

  return { t, lang }
}
